<div class="documents list default">
  <div class="items">
    <a [href]="item.links?.open" target="_blank" class="item" *ngFor="let item of items">
      <ico [ico]="ico(item.extension)"  [color]="color(item.extension)" [size]="48"></ico>
      <div class="value">
        {{item.name}}
        <div class="description">{{item.description}}</div>
      </div>
    </a>
  </div>
</div>
